<template>
    <iframe
        :title="page.title"
        :src="pageContent"
        style="width: 100vw; height: 100vh; border: none"
    />
</template>

<script setup lang="ts">
    /* eslint-disable no-useless-escape */
    // ^ is nodig voor het escapen van de forward slash in de script tag

    import useClient from '@/services/keyvue-api/composables/useClient';
    import { Page } from '@keyvue/one-api-client';
    import { computed } from 'vue';

    interface Props {
        pageId: string;
    }

    const { client } = useClient();
    const props = defineProps<Props>();
    const page = await client.get(Page, props.pageId);

    if (!page) {
        throw new Error('Page not found');
    }

    const pageContent = computed(() => {
        const editorSource = [
            import.meta.env.VITE_INNOVA_EDITOR_HOST,
            import.meta.env.VITE_INNOVA_EDITOR_BASEPATH,
        ].filter((v) => !!v).join();

        const result = `
            <!doctype html>
            <html lang="en">
            <head>
                <meta charset="UTF-8" />
                <link rel="icon" href="/favicon.ico" />
                <meta name="viewport" content="width=device-width, initial-scale=1.0" />
                <title>${page.title}</title>
                <base href="${editorSource}/">

                <link href="/assets/minimalist-blocks/content.css" rel="stylesheet" type="text/css" />
                <link href="/box/box-flex.css" rel="stylesheet" type="text/css" />
                <script src="/box/box-flex.js" type="text/javascript"><\/script>

                <link href="/assets/scripts/glide/css/glide.core.css" rel="stylesheet" type="text/css" />
                <link href="/assets/scripts/glide/css/glide.theme.css" rel="stylesheet" type="text/css" />
                <script src="/assets/scripts/glide/glide.js" type="text/javascript"><\/script>
            </head>
            <body>
                <div class="is-wrapper">
                    ${page.content}
                    ${page.mainCss}
                    ${page.sectionCss}
                </div>
            </body>
            </html>
        `;

        const blob = new Blob([result], {
            type: 'text/html',
        });

        return URL.createObjectURL(blob);
    });
</script>
